/* 车系详情 */
import React from 'react'
import get from 'lodash/get'
import Link from 'next/link'
import 'styled-jsx/css'
import getLinkHref from 'lib/get-link-href'
import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import { getZT } from 'lib/zt-util'

const show_more_icon = require('static/show-more.png')
import Image from 'Components/image'
import Button from 'Components/button'
import { useCityName } from 'Components/hooks'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import classNames from 'classnames'
const moreIconGrey = require('static/more-icon-grey@3x.png')
const moreIconYellow = require('static/right-arrow-yellow.png')
const emptyImage =
  'https://sf3-ttcdn-tos.pstatp.com/img/motor-img/106030f33daf22a3c7b1018410e74f1d~noop.png'
type IPcConfig = {
  environmental_standards: string
  driver_form: string
  fuel_comprehensive: string
  gearbox_description: string
  air_control_model_2: string
  fuel_form: string
  fuel_label: string
  seat_material: string
  engine_description: string
  is_new_energy_type: boolean
}
export interface IHeader {
  brand_name: string
  brand_id: string
  avatar_url: string
  cover_url: string
  dealer_price: string
  official_price: string
  name: string
  head_info: string
  extra: string
  entrance_list: string
  series_id: number
  car_id_list: string
  pic_summary: IImages[]
  white_cover_url: string
  motor_id: number
  vr_image: string
  pc_config: any
}
export interface IExtra {
  car_type?: string
  oil_consume?: string
  logo_url: string
}

interface IImages {
  SeriesId?: number
  Category?: string
  PicCount?: number
  CoverPicUrl: string
}
interface IProps {
  seriesId: number
  hasVR?: boolean
}

export default function Header({ seriesId, hasVR }: IProps) {
  const [params, setParams] = React.useState<IHeader>({
    brand_name: '',
    brand_id: '',
    avatar_url: '',
    cover_url: '',
    dealer_price: '',
    official_price: '',
    name: '',
    head_info: '',
    extra: '',
    entrance_list: '',
    series_id: seriesId,
    car_id_list: '',
    pic_summary: [],
    white_cover_url: '',
    motor_id: 0,
    vr_image: '',
    pc_config: {
      is_new_energy_type: false,
      environmental_standards: '',
      driver_form: '',
      fuel_comprehensive: '',
      gearbox_description: '',
      air_control_model_2: '',
      fuel_form: '',
      fuel_label: '',
      seat_material: '',
      engine_description: '',
    },
  })

  const cityName = useCityName()
  const [price, setPrice] = React.useState('')
  React.useEffect(() => {
    fetch(
      getUrl(
        `/motor/car_page/m/v1/get_head/?series_id=${seriesId}&city_name=${encodeURIComponent(
          cityName || '北京'
        )}&data_from=pc_station`
      )
    )
      .then((res: any) => get(res, 'concern_obj'))
      .then((data: any) => {
        if (!data) return
        setParams(data)
      })
      .catch((err) => {
        // no-op
      })

    fetch(
      getUrl(
        `/cloud/api/invoke/get_price_by_series_id?series_id=${seriesId}&city_name=${encodeURIComponent(
          cityName || ''
        )}`
      )
    )
      .then((res: any) => {
        if (
          !res ||
          !res.data ||
          !res.data.DealerLowPrice ||
          !res.data.DealerHighPrice
        ) {
          return
        }
        setPrice(`${res.data.DealerLowPrice}万-${res.data.DealerHighPrice}万`)
      })
      .catch((err) => {
        // no-op
      })
  }, [seriesId, cityName])

  // eslint-disable-next-line complexity
  function CarParams({ params }: { params: IHeader }) {
    let extra: IExtra
    try {
      extra = JSON.parse(params.extra)
    } catch {
      return null
    }

    const subsidyPrice = get(params, 'subsidy_price', '')
    const pirceHintText = subsidyPrice ? '补贴价格：' : '厂商指导价：'
    const priceText = subsidyPrice
      ? subsidyPrice
      : get(params, 'official_price', '')

    return (
      <section className="fl">
        <h1 className="name">
          <img className="avatar" alt="avatar" src={extra.logo_url} />

          {params.name}
        </h1>
        <div className="clearfix">
          <div className="price fl">
            <span className="dealer">
              经销商报价：
              <span className="price-line">{price || '暂无报价'}</span>
            </span>
            <span className="dealer_text">
              {pirceHintText}
              <span>{priceText || '暂无报价'}</span>
            </span>
          </div>
        </div>
        <Link
          href={`/dealer?seriesId=${seriesId}&zt=${getZT(
            'pc_series_top_title'
          )}`}
          as={`/dealer/${seriesId}?zt=${getZT('pc_series_top_title')}`}
        >
          <a target="_blank">
            <Button
              onClick={() => {
                sendTeaCommEvent('click_series_top_inquiry', {
                  car_series_id: seriesId,
                })
              }}
              type="new_primary"
              disabled={
                !params.dealer_price || params.dealer_price.indexOf('暂无') >= 0
              }
              className={`button button-price`}
            >
              询底价
            </Button>
          </a>
        </Link>
        <Link href={`/community/${seriesId}`}>
          <a target="_blank">
            <Button
              className={`button-param button button-config`}
              onClick={() => {
                sendTeaCommEvent('click_series_top_config', {
                  car_series_id: seriesId,
                })
              }}
            >
              车友圈
            </Button>
          </a>
        </Link>
        <div className="parameter">
          {params?.pc_config?.is_new_energy_type ? (
            <React.Fragment>
              {extra?.car_type ? (
                <p>
                  级别：<span>{extra.car_type}</span>
                </p>
              ) : null}
              {params?.pc_config?.recharge_mileage ? (
                <p>
                  续航：<span>{params.pc_config.recharge_mileage}</span>
                </p>
              ) : null}

              {params?.pc_config?.max_horsepower ? (
                <p>
                  最大马力：<span>{params.pc_config.max_horsepower}</span>
                </p>
              ) : null}

              {params?.pc_config?.electric_drive_number ? (
                <p>
                  电机数：
                  <span>{params?.pc_config?.electric_drive_number}</span>
                </p>
              ) : null}
              {params?.pc_config?.electric_type ? (
                <p>
                  电机类型：<span>{params.pc_config.electric_type}</span>
                </p>
              ) : null}

              {params?.pc_config?.driver_form ? (
                <p>
                  驱动方式：<span>{params?.pc_config?.driver_form}</span>
                </p>
              ) : null}

              {params?.pc_config?.acceleration_time ? (
                <p>
                  百公里加速：<span>{params.pc_config.acceleration_time}</span>
                </p>
              ) : null}

              {params?.pc_config?.max_speed ? (
                <p>
                  最高车速：<span>{params.pc_config.max_speed}</span>
                </p>
              ) : null}

              {params?.pc_config?.fuel_form ? (
                <p>
                  能源类型：<span>{params.pc_config.fuel_form}</span>
                </p>
              ) : null}

              {params?.pc_config?.battery_charge_time ? (
                <p>
                  充电时间：<span>{params.pc_config.battery_charge_time}</span>
                </p>
              ) : null}

              {params?.pc_config?.seat_material ? (
                <p>
                  座椅材质：<span>{params.pc_config.seat_material}</span>
                </p>
              ) : null}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {extra?.car_type ? (
                <p>
                  级别：<span>{extra.car_type}</span>
                </p>
              ) : null}

              {params?.pc_config?.series_displacement ? (
                <p>
                  排量：<span>{params?.pc_config?.series_displacement}</span>
                </p>
              ) : null}

              {params?.pc_config?.environmental_standards ? (
                <p>
                  环保标准：
                  <span>{params?.pc_config?.environmental_standards}</span>
                </p>
              ) : null}
              {params?.pc_config?.engine_description ? (
                <p>
                  动力：<span>{params?.pc_config?.engine_description}</span>
                </p>
              ) : null}
              {params?.pc_config?.driver_form ? (
                <p>
                  驱动方式：<span>{params.pc_config.driver_form}</span>
                </p>
              ) : null}

              {params?.pc_config?.gearbox_description ? (
                <p>
                  变速箱：<span>{params.pc_config.gearbox_description}</span>
                </p>
              ) : null}

              {params?.pc_config?.fuel_comprehensive ? (
                <p>
                  油耗：<span>{params.pc_config.fuel_comprehensive}</span>
                </p>
              ) : null}

              {params?.pc_config?.fuel_label ? (
                <p>
                  燃油标号：<span>{params.pc_config.fuel_label}</span>
                </p>
              ) : null}

              {params?.pc_config?.fuel_form ? (
                <p>
                  能源类型：<span>{params.pc_config.fuel_form}</span>
                </p>
              ) : null}

              {params?.pc_config?.air_control_model_2 ? (
                <p>
                  空调控制方式：
                  <span>{params.pc_config.air_control_model_2}</span>
                </p>
              ) : null}

              {params?.pc_config?.seat_material ? (
                <p>
                  座椅材质：<span>{params.pc_config.seat_material}</span>
                </p>
              ) : null}
            </React.Fragment>
          )}

          <a
            href={`/auto/params?carIds=${params.car_id_list}`}
            //  eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
          >
            <span
              className="show-more"
              onClick={() => {
                sendTeaCommEvent('click_series_top_config', {
                  car_series_id: seriesId,
                })
              }}
            >
              更多参数配置
              <img src={show_more_icon} />
            </span>
          </a>
        </div>
        <style jsx>
          {`
            section {
              margin-left: 16px;
            }
            .avatar {
              display: inline-block;
              margin-right: 8px;
              width: 26px;
              height: 26px;
              border: solid 0.5px #e6e8f2;
              vertical-align: middle;
              border-radius: 50%;
            }

            .name {
              display: flex;
              align-items: center;
              line-height: normal;
              margin-bottom: 12px;
              font-size: 28px;
              font-weight: 500;
              height: 36px;
            }
            .price {
              padding-right: 16px;
              height: 30px;
              margin-bottom: 16px;
            }
            .consume {
              padding-left: 15px;
            }
            .type {
              margin-top: 12px;
            }
            p {
              line-height: 1.5;
              font-size: 12px;
              color: #979aa8;
            }
            p > span {
              color: #1f2129;
            }
            .dealer {
              font-size: 14px;
              line-height: 33px;
              margin-top: -7px;
              margin-bottom: 7px;
              color: #979aa8;
            }
            .dealer > span {
              font-size: 22px;
              font-weight: 500;
              vertical-align: top;
              color: #e62021;
            }
            .dealer_text {
              margin-left: 25px;
              font-size: 14px;
              line-height: 30px;
              margin-top: -7px;
              margin-bottom: 7px;
              color: #979aa8;
            }
            .dealer_text > span {
              font-size: 16px;
              vertical-align: top;
              color: #1f2129;
            }
            .parameter {
              position: relative;
              width: 520px;
              height: 128px;
              margin-top: 16px;
              padding: 16px;
              border-radius: 2px;
              background-color: #f7f8fc;
            }
            .parameter > p {
              line-height: 24px;
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              width: 33.33%;
              height: 25%;
            }
            .show-more {
              display: flex;
              align-items: center;
              justify-content: center;
              padding-left: 10px;
              width: 108px;
              height: 30px;
              position: absolute;
              bottom: 0;
              right: 0;
              font-size: 12px;
              color: #606370;
              background: url('https://sf3-ttcdn-tos.pstatp.com/img/motor-img/30974d7713a827a2ec72806b6589bd27~noop.png')
                no-repeat center/ cover;
              text-align: center;
              cursor: pointer;
            }
            .show-more > img {
              width: 14px;
              height: 14px;
              object-fit: cover;
              object-position: center;
            }
            section :global(.button) {
              min-width: 255px;
              height: 36px;
              line-height: 36px;
              font-size: 16px;
              font-weight: normal;
            }
            section :global(.button-param) {
              margin-left: 8px;
              border: solid 1px #cccccc;
              box-sizing: border-box;
              vertical-align: top;
            }
          `}
        </style>
      </section>
    )
  }

  return (
    <section className="box clearfix">
      <Photos
        params={params}
        seriesId={seriesId}
        cityName={cityName}
        hasVR={hasVR}
      />
      <CarParams params={params} />
      <style jsx>
        {`
          section {
            width: 868px;
            height: 308px;
            padding: 9px 16px 16px;
            border-radius: 2px;
            background-color: #ffffff;
          }
          .box {
            display: flex;
            padding: 16px;
          }
        `}
      </style>
    </section>
  )
}

type HeaderProps = {
  params: IHeader
  seriesId: number
  cityName?: string
  hasVR?: boolean
}

const Photos: React.FC<HeaderProps> = (props) => {
  const { params, seriesId, hasVR } = props

  const images: IImages[] = params.pic_summary || []
  if (images.length === 0) {
    images[0] = {
      SeriesId: seriesId,
      Category: 'wg',
      PicCount: 0,
      CoverPicUrl: '',
    }
    images[1] = {
      SeriesId: seriesId,
      Category: 'ns',
      PicCount: 0,
      CoverPicUrl: '',
    }
    images[2] = {
      SeriesId: seriesId,
      Category: 'kj',
      PicCount: 0,
      CoverPicUrl: '',
    }
  }
  if (images.every((img) => img.Category !== 'vr_image')) {
    images.unshift({
      SeriesId: seriesId,
      Category: 'vr_image',
      PicCount: 0,
      CoverPicUrl: params.vr_image,
    })
  }

  const num =
    images.reduce((pre: number, cur) => {
      return pre + (cur.PicCount || 0)
    }, 0) || 0
  const categoryMap = new Map()
  categoryMap.set('wg', '外观')
  categoryMap.set('ns', '内饰')
  categoryMap.set('kj', '空间')
  categoryMap.set('vr_image', '全景看车')
  return (
    <section>
      <Link
        href={`/auto/images/list?seriesId=${seriesId}`}
        as={getLinkHref(`/auto/series/${seriesId}/images`)}
      >
        <a
          target="_blank"
          onClick={(e) => {
            if (num <= 0) {
              e.preventDefault()
            }
          }}
        >
          <div className="cover">
            <Image src={params.cover_url} transition />
            <p className="num">
              共{num}张图
              {num > 0 && <span className="avatar zoom" />}
            </p>
          </div>
        </a>
      </Link>

      <div className="photos">
        {images.length &&
          images.map((item: IImages) => {
            const category = categoryMap.get(item.Category)
            if (!category) {
              return null
            }
            return (
              <div
                className="small-cover"
                key={item.Category}
                onClick={() => {
                  sendTeaCommEvent('click_series_top_pic', {
                    car_series_id: seriesId,
                    sub_tab: category,
                  })
                }}
              >
                {item.Category === 'vr_image' ? (
                  <a
                    key="category"
                    // eslint-disable-next-line react/jsx-no-target-blank
                    target="_blank"
                    onClick={(e) => {
                      if (!item.CoverPicUrl || !hasVR) {
                        e.preventDefault()
                      }
                    }}
                    href={`https://m.dcdapp.com/motor/inapp/pano-new/inner.html?series_id=${seriesId}`}
                  >
                    <Image
                      src={item.CoverPicUrl || emptyImage}
                      transition={!!item.CoverPicUrl}
                    />
                    <p
                      className={classNames({
                        num_small: item.CoverPicUrl,
                        text: item.CoverPicUrl,
                        default: !item.CoverPicUrl,
                      })}
                    >
                      {item.CoverPicUrl && hasVR ? category : '暂无全景'}
                    </p>
                  </a>
                ) : (
                  <Link
                    key={category}
                    href={`/auto/images/list?tab=${item.Category}&seriesId=${seriesId}`}
                    as={getLinkHref(
                      `/auto/series/${seriesId}/images?tab=${item.Category}`
                    )}
                  >
                    <a
                      target="_blank"
                      onClick={(e) => {
                        if (!item.CoverPicUrl) {
                          e.preventDefault()
                        }
                      }}
                    >
                      <Image
                        src={item.CoverPicUrl || emptyImage}
                        transition={!!item.CoverPicUrl}
                      />
                      <p
                        className={classNames({
                          num_small: item.CoverPicUrl,
                          text: item.CoverPicUrl,
                          default: !item.CoverPicUrl,
                        })}
                      >
                        {item.CoverPicUrl ? '' : '暂无'}
                        {category}
                      </p>
                    </a>
                  </Link>
                )}
              </div>
            )
          })}
      </div>
      <style jsx>
        {`
          .cover {
            position: relative;
            overflow: hidden;
            width: 300px;
            height: 200px;
            border-radius: 2px;
          }
          .cover:hover .num {
            color: #ffcc32;
          }
          .cover:hover .avatar {
            background-image: url('${moreIconYellow}');
          }
          .small-cover:hover p {
            color: #ffcc32;
          }
          .num {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            line-height: 28px;
            text-align: center;
            color: #fff;

            border-radius: 2px;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0.8)
            );
          }
          .num_small {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            line-height: 22px;
            text-align: center;
            color: #fff;

            border-radius: 2px;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.4),
              rgba(0, 0, 0, 0.8)
            );
          }
          .photos {
            margin-top: 6px;
            display: flex;
          }

          .text {
            line-height: 22px;
            font-size: 12px;
          }
          .default {
            font-size: 12px;
            line-height: 22px;
            color: #979aa8 !important;
            text-align: center;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            text-align: center;
            cursor: default !important;
          }
          .small-cover {
            box-sizing: border-box;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width: 70px;
            height: 70px;
            border-radius: 2px;
            margin-right: 7px;
          }
          .small-cover:last-child {
            margin-right: 0;
          }

          .mask {
            width: 100%;
            height: 100%;
            background-color: #000000;
            opacity: 0.08;
            position: absolute;
            top: 0;
            left: 0;
          }
          .avatar {
            display: inline-block;
            width: 12px;
            height: 12px;
            background-image: url('${moreIconGrey}');
            background-position: center;
            background-size: cover;
            cursor: pointer;
            vertical-align: middle;
          }
        `}
      </style>
    </section>
  )
}
